import {
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
  IconButton,
  Tooltip,
  Box,
  Card,
  CardHeader,
} from "@mui/material";
import {
  Star,
  StarBorder,
  StarHalf,
  InfoOutlined,
  ArrowUpward,
} from "@mui/icons-material";
import { useEffect, useState } from "react";
import moment from "moment";

export const TransactionTable = ({data,formData}) => {
  const [selected, setSelected] = useState(null);
  const [compare, setCompare] = useState([]);
  const [products, setproducts] = useState([]);

  useEffect(() => {
    let productData = [];
    if (data.length) {
      data.forEach((item,i) => {
        productData.push({
            name: `Order ${i+1}`,
            Order_code: item?.order_code,
            merchant_order_code: item?.merchant_reference_code,
            Status: item?.status,
            merchant: item?.merchant_name,
            tranaction_type: item?.tranaction_type,
            amount: item?.amount,
            initiated_amount: item?.initiated_amount,
            start_date: moment(new Date( item?.start_date)).format('D-MM-YYYY'),
            utr_id: item?.utr_id,
            updated_date: moment(new Date(item?.updated_on)).format('D-MM-YYYY') ,
        })
      })
    }
    setproducts([...productData])
  },[data])
  const handleCompare = (name) => {
    setCompare((prev) =>
      prev.includes(name) ? prev : [...prev, name].slice(-6)
    );
  };

  const [hoveredRow, setHoveredRow] = useState(null);

  

  const specs = [
    {
      label: "Order code",
      key: "Order_code",
      info: "Average customer rating and total number of reviews",
      // render: (item) => (
      //   <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
      //     <Typography variant="body2" fontWeight="medium">
      //       {item.rating}
      //     </Typography>
      //     <RatingStars rating={item.rating} />
      //     <Typography variant="body2" color="text.secondary">
      //       ({item.reviews})
      //     </Typography>
      //   </Box>
      // )
    },
    {
      label: "Merchant order code",
      key: "merchant_order_code",
      info: "Product depth measurement",
    },
    {
      label: "Status",
      key: "Status",
      info: "Unique product identifier",
    },
    {
      label: "UTR ID",
      key: "utr_id",
      info: "Product height measurement",
    },
    {
      label: "Merchant",
      key: "merchant",
      info: "Pre-installed memory capacity",
    },
    {
      label: "Tranaction type",
      key: "tranaction_type",
      info: "Product exterior color finish",
    },
    {
      label: "Amount",
      key: "amount",
      info: "Product width measurement",
    },
    {
      label: "Initiated Amount",
      key: "initiated_amount",
      info: "Product width measurement",
    },
    {
      label: "Start Date",
      key: "start_date",
      info: "Product width measurement",
    },
    {
      label: "Updated Date",
      key: "updated_date",
      info: "Product width measurement",
    },
  ];

  const renderCell = (spec, product) => {
    const value = spec.render ? spec.render(product) : product[spec.key];
    const otherProduct = products.find((p) => p !== product);

    return (
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          gap: 1,
        }}
      >
        <Typography
          variant="body2"
          sx={{
            color: '#495a69',
            textAlign: "center",
          }}
        >
          {value}
        </Typography>
      </Box>
    );
  };

  return (
    <Card
      elevation={3}
      sx={{ maxWidth: "auto", mx: "auto", borderRadius: "12px", my: "10px" }}
    >
      <CardHeader
        title="Transaction Comparison"
        sx={{
          bgcolor: "grey.50",
          borderBottom: 1,
          borderColor: "divider",
        }}
      />
      <TableContainer component={Paper} elevation={0}>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell sx={{ width: "350px" }}>
                <Typography
                  variant="subtitle1"
                  fontWeight="medium"
                  sx={{ textAlign: "center" }}
                >
                  Attributes
                </Typography>
              </TableCell>
              {products.map((product, i) => (
                <TableCell key={i}>
                  <Typography
                    variant="subtitle1"
                    fontWeight="medium"
                    sx={{
                      textAlign: "center",
                      color: '#495a69',
                     }}
                    
                  >
                    {product.name}
                  </Typography>
                </TableCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody>
            {specs.length && specs.map((spec, index) => (
              <TableRow
                key={spec.key}
                hover
                onMouseEnter={() => setHoveredRow(index)}
                onMouseLeave={() => setHoveredRow(null)}
                sx={{
                  bgcolor: hoveredRow === index ? "action.hover" : "inherit",
                  "&:last-child td": { border: 0 },
                  width: "350px",
                }}
              >
                <TableCell
                  component="th"
                  scope="row"
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    gap: 1,
                    width: "350px",
                    bgcolor: "grey.50",
                  }}
                >
                  <Typography variant="body2" fontWeight="medium">
                    {spec.label}
                  </Typography>
                  {spec.info && (
                    <Tooltip title={spec.info} arrow>
                      <IconButton size="small">
                        <InfoOutlined sx={{ fontSize: "1rem" }} />
                      </IconButton>
                    </Tooltip>
                  )}
                </TableCell>
                {products?.length && products.map((product, i) => {
                  // console.log(specs[i].key,specs[index],product, "-----")
                  let isColorMarked=false
                  if (specs[index].key === "utr_id") {
                    if (formData.utr_id != product.utr_id) {
                      isColorMarked = true;
                    }
                  }

                  if (specs[index].key === "merchant_order_code" && formData.merchant_code) {
                    if (formData.merchant_code != product.merchant_reference_code) {
                      isColorMarked = true;
                    }
                  }

                  if (specs[index].key === "Order_code" && formData.order_code) {
                    if (formData.order_code != product.Order_code) {
                      isColorMarked = true;
                    }
                  
                  }
                  if (specs[index].key === "amount" && formData.amount) {
                    if (formData.amount != product.amount) {
                      isColorMarked = true;
                    }
                  }

                  return (
                    <TableCell key={i} style={{
                      background:isColorMarked && "#e47c7c91"
                    }}>{renderCell(spec, product)}</TableCell>
                  )
                })}
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </Card>
  );
};

export default TransactionTable;
